// a mapping for material icons/editor actions
// the keys in this object should correspond with the TOOLBAR actions.
// the values are the names of the corresponding material icons
// if the toolbar value is an object we assume that
// the key will look like this ${key}_${value}, e.g. header_3
export const ICON_NAME = {
  bold: 'format_bold',
  italic: 'format_italic',
  underline: 'format_underlined',
  link: 'insert_link',
  header_3: 'text_fields',
  undo: 'undo',
  redo: 'redo',
  list_ordered: 'format_list_numbered',
  list_bullet: 'format_list_bulleted',
};

const generateShortcutsItem = ({ label, title }) =>
  `<div><span data-balloon-break="" aria-label="${title}" data-balloon-pos="up">${label}</span></div>`;

const generateIcon = ({ type, title }) =>
  `<span data-balloon-pos="up" aria-label="${title}" class="material-symbols-outlined">${ICON_NAME[type]}</span>`;

export const TOOLBAR = [
  [{ header: '3' }, 'bold', 'italic', 'underline', 'link'],
  [{ list: 'bullet' }, { list: 'ordered' }],
  ['shortcuts', 'undo', 'redo'],
];

const flattenArray = (arr) => {
  const flattened = [];
  for (let i = 0; i < arr.length; i++) {
    if (Array.isArray(arr[i])) {
      flattened.push(...flattenArray(arr[i]));
    } else {
      flattened.push(arr[i]);
    }
  }
  return flattened;
};

// register material icons for the quill toolbar
export const generateIcons = ({ translate, toolbar = TOOLBAR, Quill }) => {
  const icons = Quill.import('ui/icons');
  const flattenedToolbar = flattenArray(toolbar);

  flattenedToolbar.forEach((item) => {
    if (item === 'shortcuts') {
      const title = translate(`.${item}.tooltip`);
      const label = translate(`.${item}.label`);
      icons[item] = generateShortcutsItem({ label, title });
    } else if (typeof item === 'string') {
      const title = translate(`.${item}`);
      icons[item] = generateIcon({ type: item, title });
    } else {
      const [key, value] = Object.entries(item)[0];
      const iconName = `${key}_${value}`;
      const title = translate(`.${iconName}`);
      icons[key][value] = generateIcon({ type: iconName, title });
    }
  });
};

// to be able to access quills `this`,
// we musn't use arrow functions
export function headerShortcutHandler(range) {
  const formatValue = !this.quill.getFormat(range.index).header ? '3' : false;
  this.quill.format('header', formatValue);
}

export function undoChange() {
  this.quill.history.undo();
}

export function redoChange() {
  this.quill.history.redo();
}
